import { Component, inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { TranslateModule } from "@ngx-translate/core";

export enum RequestStatus {
  PendingFriendsOfOman = 2,
  ApprovedFriendsOfOman,
  PendingTourismCompanies,
  ApprovedTourismCompanies,
}

@Component({
  selector: "app-service-status-dialog",
  standalone: true,
  imports: [TranslateModule],
  templateUrl: "./service-status-dialog.component.html",
  styleUrl: "./service-status-dialog.component.scss",
})
export class ServiceStatusDialogComponent {
  private data = inject(MAT_DIALOG_DATA);

  RequestStatus = RequestStatus;

  get status() {
    return this.data.id;
  }
}
